export default __webpack_public_path__ + "static/media/result_low.104d1e39.png";